module.exports = [
    {
        name: 'Monday thru Friday Work Hours',
        formatter: 'fixedFloat',
    },
    {
        name: 'Monday thru Friday After Hours',
        formatter: 'fixedFloat',
    },
    {
        name: 'Saturday Work Hours',
        formatter: 'fixedFloat',
    },
    {
        name: 'Saturday After Hours',
        formatter: 'fixedFloat',
    },
    {
        name: 'Sunday and Holidays',
        formatter: 'fixedFloat',
    },
];
